export const pageNames = {
	contacts: 'Contacts',
	reconciliations: 'Reconciliations',
	activityFeed: 'Activity Feed',
	myActiveProjects: 'My Active Projects',
	dashboard: 'Dashboard',
	createProject: 'Create Project',
	editProject: 'Edit Project',
	createGra: 'Create GRA',
	milestones: 'Milestones',
	userSettings: 'User Settings',
	otherActiveProjects: 'Other Active Projects',
	myCompletedProjects: 'My Completed Projects'
};

export const siteSections = {
	contacts: 'Contacts',
	dashboard: 'Dashboard',
	gra: 'Group Risk Assessment',
	home: 'Home',
	project: 'Project',
	projects: 'Projects',
	userAccount: 'User Account'
};

export const eventTypes = {
	clickAction: 'clickAction',
	pageView: 'pageView'
};

export const controlTypes = {
	button: 'Button',
	dropdown: 'Dropdown',
	toggle: 'Toggle',
	tab: 'Tab',
	icon: 'Icon',
	dragAndDrop: 'Drag & Drop',
	emailLink: 'Email Link',
	checkbox: 'Checkbox',
	calendar: 'Calendar'
};

export const clickActionNames = {
	dashboard: 'Dashboard',
	groupRiskAssessment: 'Group Risk Assessment',
	contactList: 'Contact List',
	projectWizard: 'Project Wizard',
	editProject: 'Edit Project',
	markAsCompleted: 'Mark As Completed',
	removeProject: 'Remove Project',
	deleteProject: 'Delete Project',
	rollForward: 'Roll Forward',
	myActiveProjects: 'My Active Projects',
	otherActiveProjects: 'Other Active Projects',
	myCompletedProjects: 'My Completed Projects',
	reconciliations: 'Reconciliations',
	activityFeed: 'Activity Feed',
	groupOversightProject: 'Group Oversight Project',
	createGroupOversightProject: 'Create Group Oversight Project',
	statAudits: 'Oversight Project (Stat Audits)',
	step1SelectClient: 'Step 1:Select A Client',
	step2CreateOrgChart: 'Step 2:Create Org Chart',
	step3ConnectToEyCanvas: 'Step 3:Connect To EY Canvas',
	step4ViewSummary: 'Step 4:View Summary',
	returnToPreviousStep: 'Return To A Previous Step',
	milestones: 'Milestones',
	projectManagement: 'Project Management',
	groupAudit: 'Group Audit',
	insights: 'Insights',
	reporting: 'Reporting',
	canvasClientPortal: 'Canvas Client Portal',
};

export const locationInPages = {
	topNavigation: 'In Page:Top Navigation',
	bottomNavigation: 'In Page:Bottom Navigation',
	projectPanel: 'In Page:Project Panel',
	projectMenu: 'In Page:Project Menu',
	rightNavigation: 'In Page:Right Navigation',
	projectSwitcher: 'In Page:Project Switcher',
	projectActions: 'In Page:Project Actions',
	footerBottom: 'Footer:Bottom Navigation',
	modalPopup: 'In Page:Modal Pop Up',
	reconciliationsActivity: 'In Page:Reconciliations & Activity Feed Overview',
	dashboardControl: 'In Page:Dashboard Controls'
};

export const buttonNames = {
	save: 'Save',
	cancel: 'Cancel',
	continue: 'Continue',
	back: 'Back',
	saveAsDraft: 'Save As Draft',
	finish: 'Finish',
	myCompletedProjects: 'My Completed Projects'
};

export const dashboardTabBarNames = {
	1: clickActionNames.milestones,
	2: clickActionNames.projectManagement,
	3: clickActionNames.groupAudit,
	4: clickActionNames.insights,
	5: clickActionNames.reporting,
	6: clickActionNames.canvasClientPortal,
};
